import { Controller } from "@hotwired/stimulus";
import Chart from "chart.js/auto";

// The evolution of the « Flux de trésorerie » page: what came in and what
// went out, bucket by bucket (day, month or year). Bars for a short series,
// a line when it is long or cumulated.
export default class extends Controller {
  static values = {
    labels: Array,
    entries: Array,
    exits: Array,
    entriesLabel: String,
    exitsLabel: String,
    kind: { type: String, default: "bar" },
  };

  connect() {
    const styles = getComputedStyle(document.documentElement);
    const green = styles.getPropertyValue("--g4s-green").trim() || "#47A534";
    const red = styles.getPropertyValue("--g4s-danger").trim() || "#E1463E";
    const line = this.kindValue === "line";
    const money = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 });

    this.chart = new Chart(this.element, {
      type: this.kindValue,
      data: {
        labels: this.labelsValue,
        datasets: [
          this.dataset(this.entriesLabelValue, this.entriesValue, green, line),
          this.dataset(this.exitsLabelValue, this.exitsValue, red, line),
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: "index", intersect: false },
        plugins: {
          legend: { position: "top", align: "end", labels: { usePointStyle: true, boxWidth: 8 } },
          tooltip: {
            callbacks: { label: (item) => `${item.dataset.label} : ${money.format(item.parsed.y)} F CFA` },
          },
        },
        scales: {
          y: { beginAtZero: true, ticks: { callback: (value) => money.format(value) }, grid: { color: "#EEF1F4" } },
          x: { grid: { display: false } },
        },
      },
    });
  }

  disconnect() {
    if (this.chart) this.chart.destroy();
  }

  dataset(label, data, color, line) {
    return {
      label,
      data,
      backgroundColor: line ? `${color}22` : color,
      borderColor: color,
      borderWidth: line ? 2 : 0,
      borderRadius: line ? 0 : 4,
      fill: line,
      tension: 0.25,
      pointRadius: line && data.length > 40 ? 0 : 3,
      maxBarThickness: 36,
    };
  }
}
